import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["filter"]
  static values = { baseUrl: String }

  connect() {
    const savedFilter = localStorage.getItem("dmThreadStatusFilter") || "open"
    this.applyFilter(savedFilter, true)
  }

  select(event) {
    event.preventDefault()
    const status = event.currentTarget.dataset.status
    this.applyFilter(status, true)
  }

  applyFilter(status, shouldFetch = true) {
    this.filterTargets.forEach(filter => {
      const filterStatus = filter.dataset.status
      if (filterStatus === status) {
        filter.classList.remove("text-muted-foreground", "hover:text-foreground")
        filter.classList.add("bg-accent", "text-foreground", "font-medium")
      } else {
        filter.classList.remove("bg-accent", "text-foreground", "font-medium")
        filter.classList.add("text-muted-foreground", "hover:text-foreground")
      }
    })

    localStorage.setItem("dmThreadStatusFilter", status)

    if (shouldFetch) {
      this.fetchThreads(status)
    }
  }

  fetchThreads(status) {
    const url = new URL(this.baseUrlValue, window.location.origin)
    url.searchParams.set("tab", "threads")
    if (status !== "all") {
      url.searchParams.set("thread_status", status)
    }

    fetch(url, {
      headers: {
        "Accept": "text/vnd.turbo-stream.html"
      }
    })
    .then(response => response.text())
    .then(html => {
      Turbo.renderStreamMessage(html)
    })
  }
}
